const cryptocurrency = {
  paymentMethodName: 'Mata Uang Kripto',
  cryptocurrencyLabel: 'Mata Uang Kripto',
  cryptocurrencySelectPlaceholder: 'Pilih mata uang kripto Anda',
  protocolWarning: 'Jika pembayaran dilakukan menggunakan jaringan yang berbeda dari yang dipilih, dana dapat hilang secara permanen. Pastikan <b>dompet Anda dikonfigurasi untuk jaringan yang benar</b> sebelum melanjutkan.',
  networkLabel: 'Jaringan',
  networkSelectPlaceholder: 'Pilih jaringan Anda',
  paymentButtonLabel: 'Bayar dengan Mata Uang Kripto',
  amountLocal: 'Jumlah lokal',
  amountCrypto: 'Jumlah kripto',
  paymentCreatedTitle: 'Pembayaran Anda telah dibuat!',
  paymentCreatedSubtitle: 'Pesanan Anda akan segera selesai! Ikuti petunjuk di bawah ini untuk mengonfirmasi transaksi ini.',
  qrCodeInstruction: 'Pindai kode QR berikut di dompet Anda untuk menyelesaikan pembayaran dalam hitungan detik',
  qrCodeNetworkNotFound: 'Jaringan tidak ditemukan. Pastikan Anda telah memilih jaringan yang benar.',
  networkWarning: 'Anda membayar <b>{cryptocurrency}</b> menggunakan <b>{protocol}</b>. Pastikan untuk memilih jaringan yang benar di dompet Anda, jika tidak dana Anda dapat hilang.',
  conversionRate: 'Nilai konversi adalah 1 {currencyExt} = {formattedCryptoRate} {cryptocurrency}. Nilai ini dihitung secara real time dan dapat berfluktuasi berdasarkan nilai tukar.',
  paymentApproved: 'Pembayaran Anda sebesar <AmountText>{amountLocal}</AmountText> telah disetujui.',
  howToPayInfoTitle: 'Bagaimana cara membayar dengan Kripto?',
  howToPayOpenApp: 'Buka dompet Anda (aplikasi atau ekstensi) dan ketuk opsi Beli, Transfer, Kirim, atau Bayar.',
  howToPayQrCode: 'Pindai kode QR dan isi kolom yang diperlukan menggunakan salin dan tempel.',
  howToPayNetwork: 'Pastikan Anda memilih jaringan yang benar. Jika salah memilih, dana mungkin tidak dapat dipulihkan.',
  howToPayConfirmation: 'Lacak status di dompet Anda (Aktivitas/Riwayat) atau kembali ke halaman ini untuk menunggu konfirmasi.',
  payAgreement1: 'Dengan melanjutkan, Anda menyetujui ',
  serviceTerms: 'Syarat dan Ketentuan',
  payAgreement2: ' EBANX.',
  payWithWalletButton: 'Bayar dengan dompet kripto',
  walletRedirectInstruction: 'Anda dapat membayar dengan mengklik tombol dan akan diarahkan untuk menyelesaikan pembayaran.',
  manualQrCodeInstruction: 'Atau pindai Kode QR di bawah ini secara manual untuk melanjutkan pembayaran',

};

module.exports = cryptocurrency;
